export const BRICOLAGE = "'Bricolage Grotesque', sans-serif";
export const POPPINS = "'Poppins', sans-serif";

export const BLOG_TABS: string[] = [
  'All',
  'E-commerce',
  'Artisan',
  'Marketplace',
  'Business',
  'Culture',
  'Logistics',
  'Marketing',
];
